'use client';

import { useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';

function logGlobalError() {
  console.error('Application error');
  trackEvent('app_error', { error_type: 'unhandled' });
}

function logUnhandledRejection() {
  console.error('Application request failed');
  trackEvent('app_error', { error_type: 'unhandled_rejection' });
}

export default function GlobalErrorListeners() {
  useEffect(() => {
    window.addEventListener('error', logGlobalError);
    window.addEventListener('unhandledrejection', logUnhandledRejection);

    return () => {
      window.removeEventListener('error', logGlobalError);
      window.removeEventListener('unhandledrejection', logUnhandledRejection);
    };
  }, []);

  return null;
}
